import './common/base';
import cr$ from '../../submodules/src/script/crquery';
import Vue from './vue/common/vue-common';
import NewsletterPage from './vue/components/newsletter/NewsletterPage';

cr$.ready(() => new Vue(NewsletterPage));
